<template>
  <v-layout>
    <v-flex class="margin">
      <loading :isLoading="isLoading" />
      <snackbar />
      <!-- mobile -->
      <div v-if="mobileView" id="e3" style="max-width: 800px; margin: auto" class="grey lighten-3">
        <v-card class="v-text-field-title">
          <v-toolbar color="#216AA9" dark>
            <v-toolbar-title class="texefild-mobile">ประวัติการทำรายการ</v-toolbar-title>
          </v-toolbar>

          <v-container fluid grid-list-lg>
            <v-layout>
              <v-flex md5>
                <span class="text-b">วันที่สร้างรายการ : </span>
              </v-flex>
            </v-layout>

            <v-layout style="overflow-x: scroll">
              <v-flex md5>
                <!-- <v-text-field label="เริ่มวันที่ชำระเงิน" solo></v-text-field> -->
                <v-menu v-model="startmenu" :close-on-content-click="false" :nudge-left="100"
                  transition="scale-transition" offset-y full-width min-width="290px" single-line>
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="startdate" append-icon="mdi-calendar" v-on="on" solo single-line height="40"
                      color="black"></v-text-field>
                  </template>
                  <v-date-picker no-title v-model="startdate" @input="startmenu = false"
                    @change="defaultDate()"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex md2 class="text_b">
                <v-icon>mdi-minus</v-icon>
              </v-flex>
              <v-flex md5>
                <!-- <v-text-field label="สิ้นสุดวันที่ชำระเงิน" solo></v-text-field> -->
                <v-menu v-model="endmenu" :close-on-content-click="false" :nudge-left="100"
                  transition="scale-transition" offset-y full-width min-width="290px" single-line>
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="enddate" append-icon="mdi-calendar" v-on="on" solo single-line height="40"
                      color="black"></v-text-field>
                  </template>
                  <v-date-picker no-title v-model="enddate" @input="endmenu = false"
                    @change="defaultDate()"></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex md2 class="mt-text">
                <span class="text-b">ค้นหาโดยข้อความ : </span>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex md6>
                <v-text-field type="text" name="fill_text" id="fill_text" v-model="searchText" color="black" solo
                  label="ค้นหา">
                </v-text-field>
              </v-flex>
            </v-layout>

            <v-data-table :headers="headers" :items="transitions" :search="searchText">
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on" style="font-size: 14px; font-weight: bold; color: black">
                      {{ props.header.text }}
                    </span>
                  </template>
                  <span>
                    {{ props.header.text }}
                  </span>
                </v-tooltip>
              </template>
              <template v-slot:items="props">
                <td class="text-left" style="font-size: 13px">
                  {{ props.item.merchant_name }}
                </td>
                <td class="text-left" style="font-size: 13px">
                  {{ props.item.customer_name }}
                </td>
                <td class="text-left" style="font-size: 13px">
                  {{ props.item.order_id }}
                </td>
                <!-- <td class="text-left" style="font-size: 13px">
                  {{ props.item.order_id_eentry || '-' }}
                </td> -->
                <td class="text-xs-left" style="font-size: 13px; min-width: 150px" v-if="
                  props.item.order_id_eentry !== '' &&
                  props.item.order_id_eentry !== null
                ">
                  {{ props.item.order_id_eentry }}
                </td>

                <td class="text-left" style="font-size: 13px">
                  {{ setFormatDateTime(props.item.createdAt) }}
                </td>
                <td class="text-xs-left" style="font-size: 13px">
                  {{
                    props.item.transaction_date
                      ? setFormatDateTime(
                        `${props.item.transaction_date} ${props.item.transaction_time}`
                      )
                      : `-`
                  }}
                </td>
                <td class="text-xs-left" style="font-size: 13px" v-if="
                  props.item.payment_ref_id !== '' &&
                  props.item.payment_ref_id !== null
                ">
                  {{ props.item.payment_ref_id }}
                </td>
                <td v-else class="text-xs-center" style="font-size: 13px">-</td>
                <td class="text-xs-right" style="font-size: 13px">
                  {{ props.item.amount.toFixed(2) }}
                </td>
                <td class="text-xs-left" style="font-size: 13px" v-if="
                  props.item.payment_type !== '' &&
                  props.item.payment_type !== null
                ">
                  {{ props.item.payment_type }}
                </td>
                <td v-else class="text-xs-center">-</td>
                <td class="text-xs-left" style="font-size: 13px; min-width: 150px" v-if="
                  props.item.order_desc !== '' &&
                  props.item.order_desc !== null
                ">
                  {{ props.item.order_desc }}
                </td>
                <td v-else class="text-xs-center" style="font-size: 13px">-</td>
                <td class="text-xs-left" style="font-size: 14.5px; color: green" v-if="
                  props.item.status !== '' &&
                  props.item.status !== null &&
                  props.item.status === 'Success'
                ">
                  <!-- {{ props.item.status }} -->
                  <!-- {{
                    props.item.status === "Success"
                      ? "ชำระเงินสำเร็จ"
                      : "ชำระเงินไม่สำเร็จ"
                  }} -->
                  ชำระเงินสำเร็จ
                </td>
                <td v-else class="text-xs-left" style="font-size: 14.5px; color: red">
                  ชำระเงินไม่สำเร็จ
                </td>
                <td class="text-xs-left" style="font-size: 13px; min-width: 150px" v-if="
                  props.item.order_desc !== '' &&
                  props.item.order_desc !== null
                ">
                  {{ props.item.order_desc }}
                </td>
                <td class="text-left" style="font-size: 14.5px">
                  <v-flex>
                    <v-btn flat icon :disabled="props.item.link_payment &&
                      (props.item.status == `Fail` ||
                        props.item.status == null)
                      ? false
                      : true
                      " color="primary" @click="copyLink(props.item.link_payment)">
                      <v-icon>mdi-link-variant</v-icon>
                    </v-btn>
                  </v-flex>
                </td>
                <td style="text-align: center">
                  <v-flex>
                    <v-btn flat icon :disabled="props.item.status == 'Success'"
                      @click="deleteTransaction(props.item.id, props.item.order_id)">
                      <v-icon class="backMerchant" size="22" color="red">mdi-delete</v-icon>
                    </v-btn>
                  </v-flex>
                </td>
              </template>
            </v-data-table>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-layout align-start justify-start row fill-height>
              <ExportExcel class="ml-4 mb-4" @message-excel="handleExcel" />
            </v-layout>
          </v-container>
        </v-card>
      </div>

      <!-- Web -->
      <div v-if="!mobileView" id="e3" style="max-width: 1500px; margin: auto" class="grey lighten-3">
        <v-card class="v-text-field-title">
          <v-toolbar color="#216AA9" dark>
            <v-toolbar-title>ประวัติการทำรายการ</v-toolbar-title>
          </v-toolbar>

          <v-container fluid grid-list-lg>
            <v-layout style="margin-top: 10px">
              <v-flex md2 class="text_b">
                <span>วันที่สร้างรายการ : </span>
              </v-flex>
              <v-flex md4>
                <!-- <v-text-field label="เริ่มวันที่ชำระเงิน" solo></v-text-field> -->
                <v-menu v-model="startmenu" :close-on-content-click="false" :nudge-left="100"
                  transition="scale-transition" offset-y full-width min-width="290px" single-line>
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="startdate" append-icon="mdi-calendar" v-on="on" solo single-line height="40"
                      color="black"></v-text-field>
                  </template>
                  <v-date-picker no-title v-model="startdate" @input="startmenu = false"
                    @change="defaultDate()"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex md1 class="text_b">
                <v-icon>mdi-minus</v-icon>
              </v-flex>
              <v-flex md4>
                <v-menu v-model="endmenu" :close-on-content-click="false" :nudge-left="100"
                  transition="scale-transition" offset-y full-width min-width="290px" single-line>
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="enddate" append-icon="mdi-calendar" v-on="on" solo single-line height="40"
                      color="black"></v-text-field>
                  </template>
                  <v-date-picker no-title v-model="enddate" @input="endmenu = false"
                    @change="defaultDate()"></v-date-picker>
                </v-menu>
                <!-- <v-text-field label="สิ้นสุดวันที่ชำระเงิน" solo></v-text-field> -->
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex md2 class="text_b">
                <span>ค้นหาโดยข้อความ : </span>
              </v-flex>
              <v-flex md4>
                <v-text-field type="text" name="fill_text" id="fill_text" v-model="searchText" color="black" solo
                  label="ค้นหา">
                </v-text-field>
              </v-flex>
            </v-layout>

            <v-data-table :headers="headers" :items="transitions" :search="searchText">
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on" style="font-size: 16px; font-weight: bold; color: black">
                      {{ props.header.text }}
                    </span>
                  </template>
                  <span>
                    {{ props.header.text }}
                  </span>
                </v-tooltip>
              </template>
              <template v-slot:items="props">
                <td class="text-left" style="font-size: 14.5px">
                  {{ props.item.merchant_name }}
                </td>

                <td class="text-left" style="font-size: 14.5px">
                  {{ props.item.customer_name }}
                </td>

                <td class="text-left" style="font-size: 14.5px">
                  {{ props.item.order_id }}
                </td>
                <!-- <td class="text-left" style="font-size: 13px">
                  {{ props.item.order_id_eentry || '-' }}
                </td> -->
                <td class="text-xs-left" style="font-size: 13px; min-width: 150px" v-if="
                  props.item.order_id_eentry !== '' &&
                  props.item.order_id_eentry !== null
                ">
                  {{ props.item.order_id_eentry }}
                </td>
                <td class="" style="
                    font-size: 14.5px;
                    min-width: 160px;
                    text-align: center;
                  ">
                  {{ setFormatDateTime(props.item.createdAt) }}
                </td>
                <td class="" style="
                    font-size: 14.5px;
                    min-width: 160px;
                    text-align: center;
                  ">
                  {{
                    props.item.transaction_date
                      ? setFormatDateTime(
                        `${props.item.transaction_date} ${props.item.transaction_time}`
                      )
                      : `-`
                  }}
                </td>
                <td class="text-xs-left" style="font-size: 14.5px" v-if="
                  props.item.payment_ref_id !== '' &&
                  props.item.payment_ref_id !== null
                ">
                  {{ props.item.payment_ref_id }}
                </td>
                <td v-else class="text-xs-center" style="font-size: 14.5px">
                  -
                </td>
                <td class="text-xs-right" style="font-size: 14.5px">
                  {{ numberWithCommas(props.item.amount.toFixed(2)) }}
                </td>
                <td class="text-xs-left" style="font-size: 14.5px" v-if="
                  props.item.payment_type !== '' &&
                  props.item.payment_type !== null
                ">
                  {{ props.item.payment_type }}
                </td>
                <td v-else class="text-xs-center">-</td>
                <td class="text-xs-left" style="font-size: 14.5px" v-if="
                  props.item.order_desc !== '' &&
                  props.item.order_desc !== null
                ">
                  {{ props.item.order_desc }}
                </td>
                <td v-else class="text-xs-center">-</td>
                <td class="text-xs-left" style="font-size: 14.5px; color: green" v-if="
                  props.item.status !== '' &&
                  props.item.status !== null &&
                  props.item.status === 'Success'
                ">
                  <!-- {{ props.item.status }} -->
                  <!-- {{
                    props.item.status === "Success"
                      ? "ชำระเงินสำเร็จ"
                      : "ชำระเงินไม่สำเร็จ"
                  }} -->
                  ชำระเงินสำเร็จ
                </td>
                <td v-else class="text-xs-left" style="font-size: 14.5px; color: red">
                  ชำระเงินไม่สำเร็จ
                </td>
                <td class="text-left" style="font-size: 14.5px">
                  <v-flex>
                    <v-btn flat icon :disabled="props.item.link_payment &&
                      (props.item.status == `Fail` ||
                        props.item.status == null)
                      ? false
                      : true
                      " color="primary" @click="copyLink(props.item.link_payment)">
                      <v-icon>mdi-link-variant</v-icon>
                    </v-btn>
                  </v-flex>
                </td>
                <td style="text-align: center">
                  <v-flex>
                    <v-btn flat icon :disabled="props.item.status == 'Success'" @click="
                      deleteTransaction(props.item.id, props.item.order_id)
                      ">
                      <v-icon class="backMerchant" size="22" color="red">mdi-delete</v-icon>
                    </v-btn>
                  </v-flex>
                </td>
              </template>
            </v-data-table>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-layout align-start justify-start row fill-height>
              <ExportExcel class="ml-4 mb-3" @message-excel="handleExcel" />
            </v-layout>
          </v-container>
        </v-card>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from "moment";
import snackbar from "../components/alert/snackbar.vue";
import ExportExcel from "../components/HistoryPayment/ExportExcel.vue";
import Loading from "../components/Loading.vue";
import { EventBus } from "@/EventBus";

export default {
  components: {
    snackbar,
    ExportExcel,
    Loading,
  },
  data() {
    return {
      // startdate: '2022-01-09',
      // enddate: '2022-01-09',
      isLoading: true,
      searchText: "",
      startdate: moment().format("YYYY-MM-DD"),
      enddate: moment().format("YYYY-MM-DD"),
      startmenu: false,
      endmenu: false,
      mobileView: false,
      headers: [
        { text: "ชื่อร้านค้า", value: "merchant_name", sortable: false },
        { text: "ชื่อลูกค้า", value: "customer_name", sortable: false },
        {
          text: "เลขอ้างอิงรายการของร้านค้า",
          value: "order_id",
          sortable: false,
        },
        {
          text: "เลขอ้างอิง entry",
          value: "order_id_eentry",
          sortable: false,
        },
        {
          text: "วันที่สร้างรายการ",
          value: "createdAt",
          sortable: false,
        },
        {
          text: "วันที่ชำระเงิน",
          value: "transaction_date",
          sortable: false,
        },
        {
          text: "เลขอ้างอิงรายการชำระเงิน",
          value: "payment_ref_id",
          sortable: false,
        },

        { text: "ยอดชำระเงิน", value: "amount", sortable: false },
        { text: "ช่องทางการชำระเงิน", value: "payment_type", sortable: false },
        { text: "จดบันทึก", value: "order_desc", sortable: false },
        { text: "สถานะ", value: "status", sortable: false },
        { text: "Action", value: "action", sortable: false },
        { text: "ลบรายการ", value: "action", sortable: false },
      ],
      transitions: [],
    };
  },
  methods: {
    async alertStatusV2(title, type) {
      this.$fire({
        title: title,
        type: type,
        confirmButtonText: "ยืนยัน",
      });
    },
    async alertQuestion(title, text) {
      return new Promise((resolve, reject) => {
        this.$fire({
          title: title,
          text: text,
          type: "question",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          showCloseButton: true,
          showCancelButton: true,
        })
          .then((result) => {
            if (result.value) {
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    alertStauts(color, text) {
      EventBus.$emit("snackbarAlert", {
        color: color,
        text: text,
        timeout: 3000,
      });
    },
    async handleExcel() {
      try {
        let json_data = {
          startdate: this.startdate,
          enddate: this.enddate,
        };
        const response = await this.axios.post(
          `${process.env.VUE_APP_APIHOST}/excel_transactions`,
          { source: json_data },
          {
            headers: {
              Authorization: this.$cookies.get("token"),
            },
            responseType: "blob",
          }
        );
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = "transaction-list.xlsx";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      } catch (error) {
        this.alertStatusV2("ดาวน์โหลด Excel ไม่สำเร็จ", 'error')
      }
    },
    async deleteTransaction(id, order_id) {
      try {
        // [1] เช็คว่ามี id ส่งมาหรือไม่
        // [2] ถ้ามี id จะถูกลบจากฟังก์ชั่น deleteTransaction
        // [3] ถ้าไม่มี id จะแสดง Alert ลบรายการไม่สำเร็จ
        const result = await this.alertQuestion(
          "ลบรายการ",
          `คุณต้องการลบรายการ ${order_id} ใช่หรือไม่`
        );
        const deleteTransaction = async (id) => {
          await this.axios
            .delete(process.env.VUE_APP_APIHOST + `/transaction/${id}`, {
              headers: { Authorization: this.$cookies.get("token") },
            })
            .then(() => {
              this.alertStatusV2("ลบรายการสำเร็จ", 'success')
            });
        };
        if (result) {
          id
            ? await deleteTransaction(id).then(() => {
              this.defaultDate();
            })
            : (() => {
              throw "ลบรายการไม่สำเร็จ";
            })();
        }
      } catch (error) {
        this.alertStatusV2(error, 'error')
      }
    },
    onClickGen() {
      // this.$router.push("/urluesult");
    },
    handleView() {
      this.mobileView = window.innerWidth <= 990;
      this.$cookies.set("screenView", this.mobileView);
    },

    numberWithCommas(x) {
      x = x.toString();
      var pattern = /(-?\d+)(\d{3})/;
      while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
      return x;
    },

    setFormatDateTime: (datetime) =>
      datetime ? moment(datetime).format("YYYY-MM-DD HH:mm") : "-",
    copyLink: (textLink) => {
      navigator.clipboard
        .writeText(textLink)
        .then(() => {
          EventBus.$emit("snackbarAlert", {
            color: "success",
            text: "คัดลอกสำเร็จ",
            timeout: 3000,
          });
        })
        .catch((err) => {
          EventBus.$emit("snackbarAlert", {
            color: "error",
            text: err,
            timeout: 3000,
          });
        });
    },
    async defaultDate() {
      try {
        this.isLoading = true;
        let json_data = {
          startdate: this.startdate,
          enddate: this.enddate,
        };
        var { data: trans_data } = await this.axios.post(
          process.env.VUE_APP_APIHOST + "/transactions_list",
          { source: json_data },
          { headers: { Authorization: this.$cookies.get("token") } }
        );
        //console.log("transactions_list: ", trans_data);
        this.startdate = trans_data.startdate;
        this.enddate = trans_data.enddate;
        this.transitions = trans_data.data;
        this.isLoading = false;
      } catch (error) {
        console.log(error.message);
      }
    },
  },
  created() {
    this.handleView();
    this.defaultDate();
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Sarabun:wght@300&display=swap");

html,
body {
  font-family: "Sarabun", sans-serif;
  font-size: 16.5px;
  /* font-weight: bold; */
}

#app {
  font-family: "Sarabun", sans-serif;
  font-size: 15px;
  /* font-weight: bold; */
}

.text {
  font-size: 16px;
}

.margin {
  margin-top: 0px;
}

.layout-btn {
  justify-content: center;
}

.text_b {
  text-align: center;
  margin-top: 15px;
}

.mt-text {
  margin-top: -20px;
}

/* .d_120px_clm {
  min-width: 0px;
}
.d_150px_clm {
  min-width: 150px;
} */
.v-text-field-title {
  border: #ccc;
  border-radius: 5px;
}

.text-b {
  text-align: left;
  margin-top: 5px;
  font-weight: bold;
}

.texefild-mobile {
  font-size: 18px;
}
</style>
